import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { getComponentForEnumValue } from "./verify-card/index.js";

function VerifyingCard() {
  const [alertMessage, setAlertMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  let [params] = useSearchParams();
  const data = params.get("data");
  const { gateway, token } = useParams();
  const tData = data ?? token;
  const [componentInfo, setComponentInfo] = useState({
    component: null,
    props: {},
  });

  useEffect(() => {
    const Component = getComponentForEnumValue(gateway);
    setComponentInfo({
      component: Component,
      props: { params, token: tData },
    });
  }, [gateway, tData, params]);

  const alert = (message) => {
    setAlertMessage(message);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertMessage(null);
  };

  const { component: Component, props } = componentInfo;
  return (
    <div>
      {Component ? (
        <Component {...props} alert={alert} setIsLoading={setIsLoading} />
      ) : null}
      <Snackbar
        open={!!alertMessage}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        xl={{
          position: "fixed",
          top: 10,
          left: 10,
        }}
      >
        <Alert onClose={handleCloseAlert} severity="error" variant="filled">
          {alertMessage}
        </Alert>
      </Snackbar>

      {isLoading && (
        <div id="loading">
          <CircularProgress />
        </div>
      )}
    </div>
  );
}

export default VerifyingCard;
